var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHistoricalDrama = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Antique-Swords--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Antique Swords Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.41 1.22a2 2 0 0 0 -2.82 0c-0.29 0.29 -3.09 3.53 -4.52 5.35a0.24 0.24 0 0 1 -0.18 0.09 0.23 0.23 0 0 1 -0.19 -0.07L14.08 5a1 1 0 0 0 -1.42 1.41l1.06 1.06a0.24 0.24 0 0 1 0 0.35l-0.23 0.18a0.51 0.51 0 0 0 0 0.71l2.51 2.5a0.5 0.5 0 0 0 0.7 0l0.2 -0.21a0.25 0.25 0 0 1 0.36 0l1.06 1a1 1 0 0 0 1.41 0 1 1 0 0 0 0 -1.42l-1.68 -1.64a0.23 0.23 0 0 1 -0.05 -0.19 0.24 0.24 0 0 1 0.09 -0.18c1.75 -1.38 4.91 -4.09 5.32 -4.52a2 2 0 0 0 0 -2.83Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33 15.19a20.77 20.77 0 0 0 -5.06 7.54 0.5 0.5 0 0 0 0.64 0.64 20.62 20.62 0 0 0 7.6 -5l1.15 -1.15a0.49 0.49 0 0 0 0.15 -0.36 0.47 0.47 0 0 0 -0.15 -0.35L8.19 14a0.51 0.51 0 0 0 -0.71 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.73 15.09 10.34 7.7a0.25 0.25 0 0 1 0 -0.36l1.06 -1.06a1 1 0 0 0 0.29 -0.7 1 1 0 0 0 -1 -1 1 1 0 0 0 -0.7 0.29l-5.66 5.66a1 1 0 0 0 0.67 1.7 1 1 0 0 0 0.7 -0.29l1.1 -1.06a0.25 0.25 0 0 1 0.36 0l7.39 7.4a20.74 20.74 0 0 0 7.54 5 0.5 0.5 0 0 0 0.64 -0.64 20.57 20.57 0 0 0 -5 -7.55Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.67 7.42 1.15 -1.16a0.49 0.49 0 0 0 0.06 -0.64c-1.09 -1.5 -3 -3.94 -3.47 -4.43A2 2 0 0 0 0.59 4C0.91 4.34 3.46 6.32 5 7.47a0.51 0.51 0 0 0 0.67 -0.05Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHistoricalDrama);
export default ForwardRef;